import { Directive, ElementRef, inject, output } from '@angular/core';

@Directive({
  selector: '[clickOutside]',
  host: {
    '(document:pointerdown)': 'onClick($event)',
  },
})
export class ClickOutsideDirective {
  private elementRef = inject(ElementRef);

  readonly clickOutside = output<Event>();

  onClick(event) {
    const targetElement = event.target as HTMLElement;
    if (!targetElement) {
      return;
    }

    const path = event.path || (event.composedPath && event.composedPath()) || this.getPath(targetElement);
    const clickedInside = path.indexOf(this.elementRef.nativeElement) !== -1;
    if (clickedInside) {
      return;
    }

    this.clickOutside.emit(event);
  }

  private getPath(target) {
    const path = [];
    let currentElem = target;
    while (currentElem) {
      path.push(currentElem);
      currentElem = currentElem.parentElement;
    }
    if (path.indexOf(window) === -1 && path.indexOf(document) === -1)
      path.push(document);
    if (path.indexOf(window) === -1)
      path.push(window);
    return path;
  }
}
